import React from 'react';

export const FormActions = () => {
  return <div>FormActions</div>;
};
